<template>
  <div v-if="modal" class="dialog">
    <div class="mask"></div>
    <div class="range-modal">
      <div class="title">圈定报名范围</div>
      <Row class="content" :gutter="8">
        <div class="content-scroll">
          <div class="content-cell">
            <Col span="8" class="h-100">
              <div class="con">
                <div class="top">
                  <div
                    v-for="item in topList"
                    :key="item.key"
                    :class="[
                      'top-item',
                      item.isClassList === isClassList ? 'top-item-active' : ''
                    ]"
                    @click="handleChangeType(item)"
                  >
                    {{ item.name }}
                  </div>
                </div>
                <div class="bottom">
                  <div v-show="isClassList" class="cell">
                    <GradeList
                      :tree-data="treeData"
                      :branchid="branchId"
                      @choose="handleChoose"
                    ></GradeList>
                  </div>
                  <div v-show="!isClassList" class="cell">
                    <Select
                      v-model="stuId"
                      placeholder="请输入学生姓名"
                      filterable
                      clearable
                      :remote-method="getStudentQuerylist"
                      :loading="stuIdLoading"
                      label-in-value
                      @on-change="handleSeleteStuId"
                      @on-clear="handleClearStuId"
                    >
                      <Option
                        v-for="item in stuList"
                        :key="item.studentId"
                        :value="item.studentId"
                        >{{ item.studentName }}({{
                          `${item.gradeName}${item.className}`
                        }})</Option
                      >
                    </Select>
                    <div>
                      <div
                        v-for="item in selectStuList"
                        :key="item.value"
                        class="card"
                        @click="handleCheckStuId(item)"
                      >
                        <p>{{ item.label }}</p>
                        <Icon
                          v-show="item.check"
                          size="20"
                          type="ios-checkmark"
                        ></Icon>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <Col span="16" class="h-100">
              <div class="con">
                <div class="top">
                  <div class="top-item">可报名范围</div>
                </div>
                <div class="bottom">
                  <!-- 可报名范围 - 班级 -->
                  <div v-if="isClassList" class="cell">
                    <div class="range">
                      <div class="tip">注：人数限制为0或不填写则为不限制</div>
                      <!-- 校区全部 -->
                      <!-- <div v-if="!GradeVisibleDTOList.length">
                        <div
                          v-for="(branch, index1) in BranchVisibleDTOList"
                          :key="index1"
                          class="card"
                        >
                          <div>
                            <span class="mr-5">{{ branch.branchName }}</span>
                            <span>所有学生</span>
                          </div>
                          <div>
                            <span @click="handleClick(index1, 'branch')"><Icon type="md-close-circle" size="20"></Icon></span>
                          </div>
                        </div>
                      </div> -->
                      <!-- 班级——年级 -->
                      <div
                        v-for="(grade, index2) in GradeVisibleDTOList"
                        :key="'grade' + index2"
                        class="ground"
                      >
                        <div class="card grade-box">
                          <div>
                            <span class="mr-5">{{ grade.branchName }}</span>
                            <span>{{ grade.gradeName }}</span>
                          </div>
                          <div>
                            <!-- <span>人数限制：</span>
                            <Input
                              v-model="grade.limitCount"
                              placeholder="请填写"
                              class="w-33 mr-5"
                            ></Input> -->
                            <span
                              class="del"
                              @click="handleClick(index2, 'grade')"
                              ><Icon type="md-close-circle" size="20"></Icon
                            ></span>
                          </div>
                        </div>
                        <div
                          v-for="(clas, index3) in ClassVisibleDTOList"
                          :key="'class' + index3"
                        >
                          <div
                            v-if="clas.gradeId == grade.gradeId"
                            class="card"
                          >
                            <div>
                              <span class="mr-5">{{ clas.className }}</span>
                            </div>
                            <div>
                              <span>人数限制1：</span>
                              <Input
                                v-model="clas.limitCount"
                                placeholder="请填写"
                                class="w-33 mr-5"
                              ></Input>
                              <span
                                class="del"
                                @click="handleClick(index3, 'class')"
                                ><Icon type="md-close-circle" size="20"></Icon
                              ></span>
                            </div>
                          </div>
                        </div>
                        <!-- <div class="add-class">添加班级限制</div> -->
                      </div>
                      <div class="btn-box">
                        <Button class="mr-5" @click="handleClose()"
                          >取消</Button
                        >
                        <Button type="primary" @click="handelCalss"
                          >确定</Button
                        >
                      </div>
                    </div>
                  </div>
                  <!-- 可报名范围 - 个人 -->
                  <div v-if="!isClassList" class="cell">
                    <div
                      v-for="(item, index) in checkStuList"
                      :key="item.value"
                      class="card"
                    >
                      <p>{{ item.label }}</p>
                      <Icon
                        size="20"
                        type="ios-close-circle"
                        @click="handleDelStuId(item, index)"
                      ></Icon>
                    </div>
                    <div class="btn-box">
                      <Button class="mr-5" @click="handleClose()">取消</Button>
                      <Button type="primary" @click="handleSucStu">确定</Button>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </div>
        </div>
      </Row>
      <Modal v-model="isShowTips" @on-ok="ok" @on-cancel="cancel">
        <p>切换选择分类将清空已选结果，是否确定？</p>
      </Modal>
    </div>
  </div>
</template>
<script>
import GradeList from './GradeTree.vue';
import commonApi from '@/request/common';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';

export default {
  name: 'SelectSchoolModal',
  components: {
    GradeList
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    schoolId: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    },
    branchid: {
      type: String,
      default: ''
    },
    data: {
      type: Array,
      default() {
        return [];
      }
    },
    stuIdsList: {
      type: Array,
      default() {
        return [];
      }
    },
    classroomId: {
      type: String,
      default: ''
    }
  },
  emits: ['close', 'cancel', 'lost'],
  data() {
    return {
      isShowTips: false,
      modal: false, // 是否显示弹窗
      treeData: [],
      orgId: '',
      branchId: '',
      BranchVisibleDTOList: [], // 设定校区限制的数据
      GradeVisibleDTOList: [], // 设定年级的数据
      ClassVisibleDTOList: [], // 设定班级限制的数据
      /** 按学生 **/
      isClassList: true, // true-按班级 false-学生个人
      stuId: '',
      topList: [
        { key: 'A', name: '按年级班级', isClassList: true },
        { key: 'B', name: '按学生个人', isClassList: false }
      ],
      active: { key: 'A', name: '按年级班级', isClassList: true },
      stuIdLoading: false,
      stuList: [], // 学生列表
      selectStuList: [], // 已选学生列表
      checkStuList: [] // 已选学生列表
    };
  },
  computed: {
    ...mapGetters(['checkStuListStore'])
  },
  watch: {
    // stuIdsList(newVal) {
    //   console.log('newVal', newVal);
    //   this.checkStuList = newVal;
    //   if (this.checkStuList.length > 0) {
    //     this.setCheckStuListStore(newVal);
    //     this.active = { key: 'B', name: '按学生个人', isClassList: false };
    //     this.isClassList = false;
    //   }
    // },
    checkStuListStore(newVal) {
      if (newVal) {
        this.checkStuList = newVal;
        if (newVal.length > 0) {
          this.active = { key: 'B', name: '按学生个人', isClassList: false };
          this.isClassList = false;
        }
      }
    },
    visible(newVal) {
      this.modal = newVal;
      if (newVal) {
        this.stuId = '';
        this.checkStuList = JSON.parse(JSON.stringify(this.checkStuListStore));
        if (this.checkStuList.length > 0) {
          this.isClassList = false;
          this.active = { key: 'B', name: '按学生个人', isClassList: false };
        } else {
          this.isClassList = true;
          this.active = { key: 'A', name: '按年级班级', isClassList: true };
          this.getGradesFunc();
          this.resetDTOList();
        }
        if (this.data.length) {
          this.data.forEach(item => {
            if (item.limitCount === -1) {
              item.limitCount = '';
            }
            this.handleChoose(item);
          });
        } else {
          this.resetDTOList();
        }
      }
    },
    id(newVal) {
      this.orgId = newVal;
      if (this.orgId) {
        this.getGradesFunc();
        this.resetDTOList();
      }
    },
    data(newVal) {
      this.resetDTOList();
      if (newVal.length) {
        newVal.forEach(item => {
          if (item.limitCount === -1) {
            item.limitCount = '';
          }
          this.handleChoose(item);
        });
      }
    },
    branchid(newVal) {
      this.branchId = newVal;
      this.getGradesFunc();
    },
    schoolId(newVal) {
      // this.getStudentQuerylist('');
    }
  },
  created() {
    this.orgId = this.id;
    if (this.orgId) {
      this.getGradesFunc();
    }
  },
  methods: {
    ...mapMutations(['setCheckStuListStore']),
    handleClose() {
      this.resetDTOList();
      this.$emit('close');
    },
    // 搜索学生列表
    async getStudentQuerylist(params) {
      if (!this.schoolId) {
        return false;
      }
      const obj = {
        schoolId: this.schoolId || '',
        studentName: params || '',
        pageNum: 1,
        pageSize: 20
      };
      const resp = await commonApi.getStudentQuerylist(obj);
      if (resp.status === 200) {
        this.stuList = resp.message.list;
        console.log('resp--->', resp);
      }
    },
    handleSeleteStuId(val) {
      console.log('val', val);
      if (!val) {
        return false;
      }
      const list = this.selectStuList;
      if (list.length === 0) {
        const obj = {
          label: val.label,
          value: val.value,
          check: false
        };
        this.selectStuList.push(obj);
      } else {
        for (let i = 0; i < list.length; i++) {
          if (list[i].value === val.value) {
            this.$Message.error('已选过该学生');
            return false;
          }
        }
        const obj = {
          label: val.label,
          value: val.value,
          check: false
        };
        this.selectStuList.push(obj);
      }
    },
    handleCheckStuId(val) {
      const obj = val;
      obj.check = true;
      const list = this.checkStuList;
      if (list.length === 0) {
        // const item = JSON.parse(JSON.stringify(obj));
        this.checkStuList.push(obj);
      } else {
        for (let i = 0; i < list.length; i++) {
          if (list[i].value === val.value) {
            this.$Message.error('该学生已在可报名范围');
            return false;
          }
        }
        // const item = JSON.parse(JSON.stringify(obj));
        this.checkStuList.push(obj);
      }
    },
    handleDelStuId(val, index) {
      val.check = false;
      console.log('index', index);
      console.log('val', val);
      this.checkStuList.splice(index, 1);
    },
    handleClearStuId(val) {
      console.log('val', val);
    },
    handelCalss() {
      let status = 0;
      if (this.isClassList && this.GradeVisibleDTOList.length > 0) {
        status = 1;
      } else {
        status = 0;
      }
      const obj = {
        isLimitEnroll: status,
        arr: [
          // ...this.BranchVisibleDTOList,
          ...this.GradeVisibleDTOList
          // ...this.ClassVisibleDTOList
        ]
      };
      this.$emit('return', obj);
      console.log('圈定报名范围按照年级和班级', obj);
    },
    handleSucStu() {
      // const list = [];
      // this.checkStuList.forEach(i => {
      //   list.push(i.value);
      // });
      let status = 0;
      if (!this.isClassList && this.checkStuList.length > 0) {
        status = 2;
      } else {
        status = 0;
      }
      const obj = {
        isLimitEnroll: status,
        stuIds: this.checkStuList
      };
      this.setCheckStuListStore(this.checkStuList);
      this.$emit('returnSucStu', obj);
      console.log('圈定报名范围按了确定按钮', obj);
    },
    // 重置数据
    resetDTOList() {
      this.BranchVisibleDTOList = [];
      this.GradeVisibleDTOList = [];
      this.ClassVisibleDTOList = [];
    },
    // 删除
    handleClick(index, type) {
      if (type === 'branch') {
        this.BranchVisibleDTOList.splice(index, 1);
      } else if (type === 'grade') {
        const gradeId = this.GradeVisibleDTOList[index].gradeId;
        this.ClassVisibleDTOList = this.ClassVisibleDTOList.filter(x => {
          return x.gradeId !== gradeId;
        });
        this.GradeVisibleDTOList.splice(index, 1);
      } else {
        this.ClassVisibleDTOList.splice(index, 1);
      }
    },
    // 可报名的年级班级 type 1校区2年级3班级
    handleChoose({
      branchId,
      branchName,
      gradeId,
      gradeName,
      classId,
      className,
      limitCount = '',
      visibleId = ''
    }) {
      let data = {};
      if (this.classroomId) {
        data = {
          branchId,
          branchName,
          gradeId,
          gradeName,
          classId,
          className,
          limitCount,
          visibleId
        };
      } else {
        data = {
          branchId,
          branchName,
          gradeId,
          gradeName,
          classId,
          className,
          limitCount
        };
      }

      // console.log('..........', data);
      if (data.classId !== '0' && data.classId) {
        this.ClassVisibleDTOList.push(data);
        // Set用于数组去重,Set转数组
        // this.ClassVisibleDTOList = Array.from(new Set(this.ClassVisibleDTOList));
        this.ClassVisibleDTOList = this.filterRepeat(this.ClassVisibleDTOList);
        // this.getGradeVisibleList(data);
      } else if (data.gradeId !== '0' && data.gradeId) {
        this.getGradeVisibleList(data);
      }
      this.getBranchVisibleList(data);
    },
    // 去除数组中重复的对象 不比较limitCount(和visibleId)
    filterRepeat(obj) {
      const uniques = [];
      const stringify = {};
      for (let i = 0; i < obj.length; i++) {
        const keys = Object.keys(obj[i]);
        keys.sort(function (a, b) {
          return Number(a) - Number(b);
        });
        let str = '';
        let newOrEdit = 1; // 设置后面几位不用比较
        if (this.classroomId) {
          newOrEdit = 2;
        }
        for (let j = 0; j < keys.length - newOrEdit; j++) {
          str += JSON.stringify(keys[j]);
          str += JSON.stringify(obj[i][keys[j]]);
        }
        if (!stringify.hasOwnProperty(str)) {
          uniques.push(obj[i]);
          stringify[str] = true;
        }
      }
      return uniques;
    },
    getGradeVisibleList({
      branchId,
      branchName,
      gradeId,
      gradeName,
      classId,
      className,
      limitCount,
      visibleId = ''
    }) {
      let data = {};
      if (this.classroomId) {
        data = {
          branchId,
          branchName,
          gradeId,
          gradeName,
          classId,
          className,
          limitCount,
          visibleId
        };
      } else {
        data = {
          branchId,
          branchName,
          gradeId,
          gradeName,
          classId,
          className,
          limitCount
        };
      }
      data.classId = '0';
      data.className = '';
      this.GradeVisibleDTOList.push(data);
      this.GradeVisibleDTOList = this.filterRepeat(this.GradeVisibleDTOList);
    },
    getBranchVisibleList({
      branchId,
      branchName,
      gradeId,
      gradeName,
      classId,
      className,
      limitCount,
      visibleId = ''
    }) {
      let data = {};
      if (this.classroomId) {
        data = {
          branchId,
          branchName,
          gradeId,
          gradeName,
          classId,
          className,
          limitCount,
          visibleId
        };
      } else {
        data = {
          branchId,
          branchName,
          gradeId,
          gradeName,
          classId,
          className,
          limitCount
        };
      }
      data.classId = '0';
      data.className = '';
      data.gradeId = '0';
      data.gradeName = '';
      data.visibleId = '';
      this.BranchVisibleDTOList.push(data);
      this.BranchVisibleDTOList = this.filterRepeat(this.BranchVisibleDTOList);
    },
    // 获取年级
    async getGradesFunc() {
      if (!this.orgId) {
        this.treeData = [];
        return;
      }
      const params = {
        orgId: this.orgId
      };
      const res = await this.$http.getGradesNew(params);
      if (res.status === 200) {
        this.treeData = res.message.branches;
      }
    },

    // 返回结果
    handleReturn() { },
    handleChangeType(item) {
      console.log(this.active.isClassList, item.isClassList);
      if (this.active.isClassList === item.isClassList) {
        console.log('不能选中');
        return false;
      }
      this.isShowTips = true;
      this.active = item;
      this.isClassList = item.isClassList;
      console.log(this.active, item, 'shiahA ---');
      if (this.active.isClassList) {
        this.getGradesFunc();
        this.resetDTOList();
        this.stuId = '';
      }
    },
    ok() {
      this.isClassList = this.active.isClassList;
      if (this.isClassList) {
        this.BranchVisibleDTOList = [];
        this.GradeVisibleDTOList = [];
        this.ClassVisibleDTOList = [];
      } else {
        this.checkStuList = [];
        this.selectStuList = [];
      }
    },
    cancel() {
      this.active = {};
      this.isShowTips = false;
    }
  }
};
</script>
<style lang="scss" scoped>
// 弹窗
.dialog {
  .mb-5 {
    margin-bottom: 20px;
  }
  .mr-5 {
    margin-right: 20px;
  }
  .w-33 {
    width: 144px;
  }
  .ml-38 {
    margin-left: 164px;
  }
  .h-100 {
    height: 100%;
  }
  // 遮盖层
  .mask {
    position: fixed;
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.5);
    top: 0;
    left: 0;
    z-index: 1005;
  }
  // 对话框高度
  .dialog-hight {
    height: 319px;
  }
  // 对话框
  .range-modal {
    position: fixed;
    width: 1200px;
    height: 800px;
    background: #ffffff;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    z-index: 1006;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    .title {
      width: 100%;
      height: 40px;
      background: rgb(247, 248, 250);
      padding-left: 20px;
      line-height: 40px;
      font-weight: 600;
      border-radius: 8px;
    }
    .content {
      flex: 1;
      padding: 16px;
      overflow: hidden;
      .content-scroll {
        width: 100%;
        height: 100%;
        overflow-y: scroll;
        .content-cell {
          width: 100%;
          min-height: 100%;
          display: flex;
        }
      }
      .content-scroll::-webkit-scrollbar {
        display: none;
      }
      .con {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        .top {
          width: 100%;
          height: 45px;
          display: flex;
          flex-direction: row;
          .top-item {
            flex: 1;
            height: 100%;
            text-align: center;
            line-height: 45px;
            cursor: pointer;
          }
          .top-item-active {
            background-color: #488ffa;
            border-color: #488ffa;
            color: #fff;
          }
        }
        .bottom {
          flex: 1;
          .cell {
            width: 100%;
            height: 100%;
            padding: 20px 20px;
            background: rgb(247, 248, 250);
            border-radius: 8px;
            overflow: auto;
            .ground {
              background-color: #fff;
              border-radius: 8px;
              margin: 8px 0;
              padding: 8px 0;
            }
            .card {
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              height: 40px;
              align-items: center;
              padding: 0 32px;
              .do {
                width: 300px;
              }
              .close-icon {
                width: 30px;
                height: 30px;
                color: #fff;
                text-align: center;
                line-height: 30px;
                border-radius: 50%;
              }
            }
          }
        }
      }
    }
  }
}
</style>
